export function computeModalTranslations(
  currentSegmentContainerId,
  translationsData,
  segments
) {
  if (!currentSegmentContainerId) return null;

  const segId = parseInt(currentSegmentContainerId.split("_")[1], 10);
  const segmentTrans = translationsData.find(
    (t) => t.type === "SEGMENT" && t.id === segId
  );
  const itemIds = segments[currentSegmentContainerId] || [];
  const itemTrans = translationsData.filter(
    (t) => t.type === "ITEM" && itemIds.includes(t.id)
  );

  const result = [];
  if (segmentTrans) {
    result.push(segmentTrans);
  }

  return result.concat(itemTrans);
}
